// extracted by mini-css-extract-plugin
export default {"badge":"BW5a2","smallIos":"FFQLJ","smallAndroid":"LPyfG","buttonSize":"f6NEl","downloadButton":"mPkRJ"};